/**
 * Волна E (docs/MIGRATION_ROUTER.md §5).
 * Было: <CacheDataRoute exact path='/bar-menu/:barId/:tableId/categories/:categoryType' withoutFooter withoutHeader>.
 * path в staticData — для consent-модалки Header (includes('/bar-menu/')).
 */
import { createFileRoute } from '@tanstack/react-router';
import CacheDataRoute from '../../../../../CacheDataRoute';
import BarMenuCategory from '@routes/BarMenu/stages/BarMenuCategory';

export const Route = createFileRoute('/bar-menu/$barId/$tableId/categories/$categoryType')({
  staticData: {
    layout: {
      path: '/bar-menu/:barId/:tableId/categories/:categoryType',
      withoutHeader: true,
      withoutFooter: true
    }
  },
  component: () => (
    <CacheDataRoute component={BarMenuCategory} path='/bar-menu/:barId/:tableId/categories/:categoryType' />
  )
});
